import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { addususcritor, setModal, setSpinersli } from "StoreRedux/Slice/SuscritorSlice"
import { setToastes } from "StoreRedux/Slice/ToastSlice"
import { GetMetodo, GetValores, getVerTienda } from "utils/CarritoLocalStorang"
import { FilasSubtotal, FilasTotal } from "views/Components/DesgloseDescuento"
import CodigoDescuento from "views/Components/CodigoDescuento"
import { DatosUsuariocliente, DatosUsuarioLocalStorang, Metodos, ComisionesPago } from "utils/constantes"
import { clienteInfo, getCedula, getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag"
import { buscarcliente } from "utils/Querypanelsigui"
import { ListarMetodosPagoActivos } from "utils/ConfiguracionPagosQuery"
import axios from "../../../../node_modules/axios/index"

import ReactGA from 'react-ga4';
import { logWithCallback } from "utilsstile.js/style"
const TRACKING_ID = "G-LJN507B5NX";
export default function FormasPagoMopadal() {

    useEffect(() => { ReactGA.initialize(TRACKING_ID); }, []);
    let modal = useSelector((state) => state.SuscritorSlice.modal)
    const [listarCarritoDetalle, setListarCarritoDetalle] = useState([])
    let usedispatch = useDispatch()
    const [checked, setChecked] = useState({
        Efectivo: "",
        Fisico: "",
        Tarjeta: "",
        Deposito: "",
        Transferencia: "",
        Duna: "",
        PagoPlux: "",
        Payphone: ""
    })
    const userauthi = useSelector((state) => state.SuscritorSlice)
    const [check, setCheck] = useState(true)
    const [select, setSelecte] = useState("")
    const [gatewaysActivos, setGatewaysActivos] = useState(null)
    function handelMetodopago(target, value) {
        if (target.name == "selctmet") {
            setSelecte(target.value)
            let names = target.value.replace("Efectivo-Local", "Fisico")
            setChecked({
                [names]: target.value,
            })
            sessionStorage.setItem(Metodos, target.value)
            ListaPrecioset(GetValores())
        } else {
            setChecked({
                [target.name]: value,
            })
            setSelecte(value)
            sessionStorage.setItem(Metodos, value)
            setCheck(false)
            ListaPrecioset(GetValores())
        }

    }
    const [listaPrecio, ListaPrecioset] = useState({
        total: 0,
        subtotal: 0,
        comision: 0,
        comision_bancaria: 0,
        desc: 0,
        iva: 0,
        desctc: 0
    })
    function ConsultarUsuaioconsultarcorreo() {
        //usedispatch(setModal({ nombre: 'loginpage', estado: "e" }))
        //return
        $.confirm({
            theme: 'supervan',
            closeIcon: true,
            title: 'Firma',
            content: 'Verificar que el voucher tenga la cédula correcta y firma',
            type: 'red',
            buttons: {
                tryAgain: {
                    text: 'Ver ',
                    btnClass: 'btn-red',
                    action: function () {
                        window.open(nombres.status_pg, "_blank")

                    }
                },
                aproba: {
                    text: "Aprobar ",
                    btnClass: 'btn-success',
                    action: function () {

                    }
                },
                rechaza: {
                    text: "Rechazar",
                    btnClass: 'btn-success',
                    action: function () {

                    }
                }
            }
        });
    }
    let spinercarga = document.getElementById("spinercarga")
    function consultarcorreo(e) {
        let user = getDatosUsuariosLocalStorag()
        usedispatch(setModal({ nombre: '', estado: 'e' }))
        ReactGA.event({
            category: user.cedula,
            action: "Correo",
            label: "buscar",
        })
        $.confirm({
            title: 'Por favor ingresé correo electrónico para continuar con su compra',
            theme: "material",
            content: '' +
                '<div  className="formName">' +
                '<div className="form-group">' +
                '<label>Ingrese su correo</label>' +
                '<input type="text" placeholder="correo" class="form-control correocodigo " required />' +
                '</div>' +
                '</div>',
            buttons: {
                formSubmit: {
                    text: 'Aceptar',
                    btnClass: 'btn-blue',
                    action: function (ev) {
                        //   ev.preventDefault()
                        var name = this.$content.find('.correocodigo').val();
                        if (!name) {
                            $.alert('Ingrese un correo valido');
                            return false;
                        }
                        spinercarga.classList.remove("d-none");

                        buscarcliente({
                            "cedula": '',
                            "email": name
                        }).then(async e => {
                            if (e.success) {
                                const cedula = await getCedula(e.data.cedula)
                                var hoy = new Date();

                                usedispatch(setToastes({
                                    show: true,
                                    message: "Usuario encontrado " + e.data.nombreCompleto,
                                    color: 'bg-info',
                                    estado: "Encontrado",
                                }))

                                spinercarga.classList.add("d-none");
                                LogeodeCedula(name)
                            } else {
                                spinercarga.classList.add("d-none")

                                usedispatch(setModal({ nombre: 'registro', estado: "e" }))
                                usedispatch(setToastes({
                                    show: true,
                                    message: "Registre el usuario",
                                    color: 'bg-danger',
                                    estado: "Usuario no encontrado ",
                                }))
                            }
                        })
                    }
                },
                cancel: function () {
                    //spinercarga.classList.remove("d-none");
                    usedispatch(setModal({ nombre: 'formasPago', estado: "e" }))
                }
            }
        })
    }
    function LogeodeCedula(cor) {

        $.confirm({
            title: 'Por favor ingresé la contraseña para continuar con la compra',
            theme: "material",
            content: '' +
                '<div  className="formName">' +
                '<div className="form-group">' +
                '<label>Ingrese su contraseña</label>' +
                '<input type="text" placeholder="contraseña" class="form-control passwor " required />' +
                '</div>' +
                '</div>',
            buttons: {
                formSubmit: {
                    text: 'Continuar',
                    btnClass: 'btn-blue',
                    action: async function () {
                        var name = this.$content.find('.passwor').val();
                        var hoy = new Date();
                        if (!name) {
                            $.alert('Ingrese un correo valido');
                            return false;
                        } else {
                            spinercarga.classList.remove("d-none");
                            let randon = sessionStorage.getItem("random")
                            axios.post("https://api.t-ickets.com/ms_login/api/v1/auth_suscriptor", { email: String(cor).trim(), password: String(name).trim() }, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                                }
                            }).then(function (data) {

                                if (data.data.success) {
                                    getCedula(data.data.data.cedula).then(cedula => {
                                        let client = {
                                            cedula: data.data.data.cedula,
                                            direccion: data.data.data.ciudad,
                                            whatsapp: data.data.data.movil,
                                            telefono: data.data.data.movil,
                                            name: data.data.data.nombreCompleto,
                                            email: data.data.data.email, hora: String(hoy),
                                            enable: data.data.data.enable, id: data.data.data.id,
                                            discapacidad: 'No',
                                            envio: ''
                                        }
                                        window.gtag('event', 'login', {
                                            method: "email"
                                        });
                                        ReactGA.event({
                                            category: data.data.data.cedula,
                                            action: "login",
                                            label: "buscar",
                                            method: "email",
                                            'userId': data.data.data.cedula
                                        })

                                        sessionStorage.setItem(DatosUsuariocliente, JSON.stringify(client))
                                        sessionStorage.setItem(DatosUsuarioLocalStorang, JSON.stringify(client))
                                        usedispatch(addususcritor({ ...client }))
                                        usedispatch(setToastes({
                                            show: true,
                                            message: "Bienvenido " + data.data.data.nombreCompleto,
                                            color: 'bg-success',
                                            estado: "Inicio de sesión correcta",
                                        }))

                                        usedispatch(setModal({ nombre: 'ModalDetalle', estado: "e" }))

                                        if (randon) {
                                            axios.post("https://api.t-ickets.com/ms_login/api/v1/actulizar_identificacion_asiento",
                                                {
                                                    "random": randon,
                                                    "cedula": data.data.data.cedula
                                                },
                                                {
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                                                    }
                                                }
                                            ).then(e => {
                                                spinercarga.classList.add("d-none");
                                                //useDispatch(setSpinersli({ spiner: false }))
                                            }).catch(err => {
                                                spinercarga.classList.add("d-none");
                                                logWithCallback(err)
                                            })

                                        } else {
                                            spinercarga.classList.add("d-none");
                                        }

                                    }).catch(err => {
                                        logWithCallback(err)
                                        spinercarga.classList.add("d-none");
                                        usedispatch(setModal({ nombre: 'formasPago', estado: "e" }))
                                        //return false
                                    })

                                } else {
                                    spinercarga.classList.add("d-none");
                                    $.alert("Hubo un error Verifique su contraseña e intente de nuevo")
                                    usedispatch(setModal({ nombre: 'formasPago', estado: "e" }))
                                }

                            }).catch(err => {
                                logWithCallback(err)
                                spinercarga.classList.add("d-none");
                                $.alert("Hubo un error Verifique su contraseña e intente de nuevo")
                                usedispatch(setModal({ nombre: 'formasPago', estado: "e" }))
                            })
                        }
                    }
                },
                cancel: function () {
                    usedispatch(setModal({ nombre: 'formasPago', estado: "e" }))
                }
            }
        })
    }

    useEffect(() => {
        if (modal.nombre == "formasPago" && gatewaysActivos === null) {
            const codigoEvento = JSON.parse(sessionStorage.getItem("infoevento") || "{}")?.codigoEvento
            ListarMetodosPagoActivos(codigoEvento).then((resp) => {
                const activos = Array.isArray(resp?.data) ? resp.data.filter((g) => g.activo).map((g) => g.metodo) : null
                setGatewaysActivos(activos)
                if (Array.isArray(resp?.data)) sessionStorage.setItem(ComisionesPago, JSON.stringify(resp.data))
            }).catch(() => setGatewaysActivos(null))
        }
    }, [modal.nombre])

    useEffect(() => {
        let metodoPago = GetMetodo()
        metodoPago != null ? setChecked({
            Fisico: metodoPago == "Efectivo-Local" ? "Efectivo-Local" : "",
            Efectivo: metodoPago == "Efectivo" ? "Efectivo" : "",
            Tarjeta: metodoPago == "Tarjeta" ? "Tarjeta" : "",
            Deposito: metodoPago == "Deposito" ? "Deposito" : "",
            Transferencia: metodoPago == "Transferencia" ? "Transferencia" : "",
            Duna: metodoPago == "Duna" ? "Duna" : "",
            PagoPlux: metodoPago == "PagoPlux" ? "PagoPlux" : "",
            Payphone: metodoPago == "Payphone" ? "Payphone" : ""
        }) : handelMetodopago({ name: 'PagoPlux' }, "PagoPlux"), setCheck(false)
        sethideComision(["Tarjeta", "Tarjeta-Local", "Transferencia", "Deposito", "Duna", "PagoPlux", "Payphone", "Stripe", "PayPal", "Efectivo", "Efectivo-Local", "Efectivo-Fisico", "Efectivo-QR", "Tarjeta-QR"].includes(metodoPago) ? "" : "d-none")
        ListaPrecioset(GetValores())
        setListarCarritoDetalle(getVerTienda())
    }, [(modal.nombre == "formasPago"), select])
    const [hidecomision, sethideComision] = useState("d-none")

    return (
        <>
            <Modal
                show={modal.nombre == "formasPago" ? true : false}
                fullscreen={'md-down'}
                centered
            >
                <Modal.Header className="py-3">
                    <h5>Seleccione la Formas de Pago</h5>
                    <button className="close " onClick={() => usedispatch(setModal({ nombre: "ModalCarritov", estado: "" }))}>X</button>
                </Modal.Header>
                <Modal.Body className="row  " >
                    <div className=" d-flex  ">
                        <div className=""
                        >
                            <strong> Método de pago</strong>

                            {/* Tarjeta de credito (Abitmedia/pagomedios) - ya no se usa, se deja comentado nada mas */}
                            {/*
                            <div className="form-check">
                                <input className="v-check form-check-input" type="radio"
                                    checked={checked.Tarjeta == "Tarjeta" ? true : false}
                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Tarjeta")}
                                    name="Tarjeta" id="Tarjeta" />
                                <label className="form-check-label" htmlFor="Tarjeta">
                                    Tarjeta de credito
                                </label>
                            </div>
                            */}
                            {gatewaysActivos === null || gatewaysActivos.includes("PagoPlux") ? <div className="form-check ">
                                <input className="v-check form-check-input " type="radio"
                                    checked={checked.PagoPlux == "PagoPlux" ? true : false}
                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "PagoPlux")}
                                    name="PagoPlux" id="PagoPlux" />
                                <label className="form-check-label" htmlFor="PagoPlux">
                                    Tarjeta de Crédito
                                </label>
                            </div> : ""}
                            {gatewaysActivos === null || gatewaysActivos.includes("Payphone") ? <div className="form-check ">
                                <input className="v-check form-check-input " type="radio"
                                    checked={checked.Payphone == "Payphone" ? true : false}
                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Payphone")}
                                    name="Payphone" id="Payphone" />
                                <label className="form-check-label" htmlFor="Payphone">
                                    Payphone
                                </label>
                            </div> : ""}
                            {gatewaysActivos === null || gatewaysActivos.includes("Duna") ? <div className="form-check ">
                                <input className="v-check form-check-input " type="radio"
                                    checked={checked.Duna == "Duna" ? true : false}
                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Duna")}
                                    name="Duna" id="Duna" />
                                <label className="form-check-label" htmlFor="Duna">
                                    Banco pichincha /Deuna
                                </label>
                            </div> : ""}
                            {clienteInfo() == null && (gatewaysActivos === null || gatewaysActivos.includes("Transferencia")) ?
                                <div className="form-check">
                                    <input className="form-check-input " type="radio"
                                        checked={checked.Transferencia == "Transferencia" ? true : false}
                                        onChange={(e) => handelMetodopago({ name: e.target.name }, "Transferencia")}
                                        name="Transferencia" id="Transferencia" />
                                    <label className="form-check-label" htmlFor="Transferencia">
                                        Transferencia/Deposito
                                    </label>
                                </div> : ""}

                            {
                                clienteInfo() == null ? <div className="form-check d-none ">
                                    <input className="form-check-input" type="radio"
                                        checked={checked.Deposito == "Deposito" ? true : false}
                                        onChange={(e) => handelMetodopago({ name: e.target.name }, "Deposito")}
                                        name="Deposito" id="Deposito" />
                                    <label className="form-check-label" htmlFor="Deposito">
                                        Transferencia/Deposito
                                    </label>
                                </div> : ""}


                            {clienteInfo() == null && (gatewaysActivos === null || gatewaysActivos.includes("Efectivo")) ? <div className="form-check ">
                                <input className="v-check form-check-input" type="radio"
                                    name="Efectivo" id="Efectivo"
                                    checked={checked.Efectivo == "Efectivo" ? true : false}
                                    onChange={(e) => handelMetodopago(e.target, "Efectivo")}
                                />
                                <label className="form-check-label" htmlFor="Efectivo">
                                    Banco Guayaquil / App
                                </label>
                            </div> : ""}

                            {clienteInfo() != null && (gatewaysActivos === null || gatewaysActivos.includes("Efectivo-Local")) ? <div className="form-check">
                                <input className="v-check form-check-input" type="radio"
                                    name="Fisico" id="Fisico"
                                    checked={checked.Fisico == "Efectivo-Local" ? true : false}
                                    onChange={(e) => handelMetodopago(e.target, "Efectivo-Local")}
                                />
                                <label className="form-check-label" htmlFor="Fisico">
                                    Efectivo punto de pagos
                                </label>
                            </div> : ""}
                            {/*
                                estdo != "ACTIVO" ? <div className="form-check ">
                                    <input className="form-check-input" type="radio"
                                        checked={checked.Deposito == "Deposito" ? true : false}
                                        onChange={(e) => handelMetodopago({ name: e.target.name }, "Deposito")}
                                        name="Deposito" id="Deposito" />
                                    <label className="form-check-label" htmlFor="Deposito">
                                        Reservar
                                    </label>
                                </div> : ""
                            */}
                            {clienteInfo() != null && (gatewaysActivos === null || gatewaysActivos.includes("Transferencia")) ?
                                <div className="form-check">
                                    <input className="form-check-input" type="radio"
                                        checked={checked.Transferencia == "Transferencia" ? true : false}
                                        onChange={(e) => handelMetodopago({ name: e.target.name }, "Transferencia")}
                                        name="Transferencia" id="Transferencia" />
                                    <label className="form-check-label" htmlFor="Transferencia">
                                        Transferencia
                                    </label>
                                </div>
                                : ""}
                           


                        </div>
                    </div>
                    <div className=" col-12">
                        <div className="container-fluid table-responsive px-0">
                            {<table className="resumen-table table ">
                                <thead>
                                    <tr className="text-black">
                                        <th scope="col" className="text-black">CONCIERTO</th>
                                        <th className="text-black">LOCALIDAD</th>

                                        <th className="text-black" scope="col">ASIENTO</th>
                                        <th className="text-black" scope="col">TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listarCarritoDetalle.length > 0 ?
                                            listarCarritoDetalle.map((item, index) => {
                                                const precioUnitario = (clienteInfo() != null && getDatosUsuariosLocalStorag()?.discapacidad == "Si")
                                                    ? parseFloat(item?.localidaEspacio?.precio_discapacidad || item.valor || 0)
                                                    : parseFloat(item?.valor || 0)
                                                const factorBoletos = Number(item?.localidaEspacio?.factor_boletos || item?.factor_boletos || 1)
                                                const cantidadAsientos = Number(item?.cantidad || 0)
                                                const cantidadCobro = factorBoletos > 1
                                                    ? Math.ceil(cantidadAsientos / factorBoletos)
                                                    : cantidadAsientos
                                                const totalItem = precioUnitario * cantidadCobro
                                                return (
                                                    <tr key={index}>
                                                        <td className="align-self-center">{item.nombreConcierto}</td>
                                                        <td className="align-self-center">{item.localidad}</td>
                                                        <td className="align-self-center">{item.cantidad}</td>
                                                        <td className="align-self-center">${totalItem.toFixed(2)}</td>
                                                    </tr>
                                                )
                                            })
                                            : <tr></tr>
                                    }
                                </tbody>
                            </table>}
                        </div>
                        <div>
                            <table className="table table-borderless ">
                                <tbody style={{
                                    lineHeight: 1
                                }}>
                                    <FilasSubtotal precios={listaPrecio} />

                                    <tr>
                                        <th scope="row"></th>
                                        <td className='text-end' >Servicio Em. por Boleto:</td>
                                        <td className='text-center'>${parseFloat(listaPrecio.comision).toFixed(2)}</td>
                                    </tr>
                                    <tr className=''>
                                        <th scope="row"></th>
                                        <td className='text-end' >Iva %:</td>
                                        <td className='text-center'>${parseFloat(listaPrecio.iva).toFixed(2)}</td>
                                    </tr>
                                    <tr className={["Tarjeta", "Tarjeta-Local", "Transferencia", "Deposito", "Duna", "PagoPlux", "Payphone", "Stripe", "PayPal", "Efectivo", "Efectivo-Local", "Efectivo-Fisico", "Efectivo-QR", "Tarjeta-QR"].includes(String(select || GetMetodo())) ? '' : 'd-none'}>
                                        <th scope="row"></th>
                                        {<td className={" text-end"} >Comisión Bancaria:</td>}
                                        {<td className={" text-center"}>${parseFloat(listaPrecio.comision_bancaria).toFixed(2)}</td>}
                                    </tr>
                                    <FilasTotal precios={listaPrecio} />
                                </tbody>
                            </table>
                        </div>
                        <CodigoDescuento
                            codigoEvento={(() => { try { return JSON.parse(sessionStorage.getItem("infoevento") || "{}")?.codigoEvento } catch (_e) { return "" } })()}
                            onCambio={() => ListaPrecioset(GetValores())}
                        />
                        <div className="row p-1 d-none float-rigth">
                            <div className="col-6 col-lg-8 text-end d-flex align-items-end flex-column  ">
                                <div>
                                    <h4>Subtotal:</h4>
                                </div>
                                <div>
                                    <p>Comisión por Boleto:</p>
                                </div>
                                <div>
                                    <p>Iva:</p>
                                </div>
                                <div className={hidecomision}>
                                    <p>Comisión Bancaria:</p>
                                </div>
                                <div>
                                    <h4>Total</h4>
                                </div>
                                <div className=''>
                                    <h4></h4>
                                </div>Total Desc:
                            </div>
                            <div className="col-6 col-sm text-end align-items-end flex-column ">
                                <div className="container ">
                                    <h4 className="subtotal">${parseInt(listaPrecio.subtotal).toFixed(2)} </h4>
                                </div>
                                <div className="container-fluid">
                                    <h4 className="comision-boleto text-end">${parseInt(listaPrecio.comision).toFixed(2)} </h4>
                                </div>
                                <div className="container-fluid">
                                    <h4 className="comision-boleto text-end">${parseInt(listaPrecio.comision).toFixed(2)} </h4>
                                </div>
                                <div className={"container-fluid " + hidecomision}>
                                    <h4 className="comision-boleto text-end">${parseFloat(listaPrecio.comision_bancaria).toFixed(2)} </h4>
                                </div>
                                <div className="container  ">
                                    <h4 className="total-text"> ${parseFloat(listaPrecio.total).toFixed(2)} </h4>
                                </div>
                                <div className="container -none ">
                                    <h4 className="total-text"> ${GetMetodo() === "Tarjeta" ? parseFloat(listaPrecio.desctc).toFixed(2) : parseFloat(listaPrecio.desc).toFixed(2)} </h4>
                                </div>

                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className=" justify-content-center">

                    <button onClick={() => (userauthi.login) ? usedispatch(setModal({ nombre: "ModalDetalle", estado: "" })) : consultarcorreo()} className=" btn btn-success"> Continuar </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}